var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.01,
    height: 5.5,
    viewBox: "0 0 10.01 5.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48639",
    "data-name": "Path 48639",
    d: "M.5,10.01a.47.47,0,0,1-.35-.15.5.5,0,0,1,0-.71L4.3,5,.15.86a.5.5,0,0,1,0-.71.5.5,0,0,1,.71,0L5.35,4.66a.5.5,0,0,1,0,.71L.85,9.86a.5.5,0,0,1-.35.15",
    transform: "translate(10.01) rotate(90)",
    fill: "#231f20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBlack);
export default __webpack_public_path__ + "static/media/down_arrow_black.56afad3c212f5fbd737e0b2378b68f85.svg";
export { ForwardRef as ReactComponent };